const Permission = {

    // FIELDS
    "role": "Role",
    "type": "Type",
    "is_subscription": "Is Subscription",
    "subscription": "Subscription",
    "permission": "Permission",
    "search": "Search",
    
    // BUTTON
    "submit": "Save",

    // PAGE HEADER
    "assingn_permission": "Assign Permission",

    // TOAST
    "success_add": "Created Successfully",
    "wrong": "Something went wrong",

    // ERROR
    "error_role": "Select Role",
    "error_type": "Select Type",
    "error_is_subscription": "Select Is Subscription",
    "error_subscription": "Select Subscription",
    "error_permission": "Check at Least One Permission",

}

export default Permission;
